import styled, { css } from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { container } from '../../styles/mixins';
import { ZINDEX } from '../../helpers/constants';

export const getDraggableStyle = (style, snapshot) => {
  const { isDragging } = snapshot;
  const { transition } = style;

  let newStyle = {
    ...style,
    width: '100%',
  };

  if (isDragging) {
    const customTransition = 'background-color 0.33s ease, width 0.33s ease, box-shadow 0.33s ease';

    newStyle = {
      ...newStyle,
      transition: `${customTransition}${transition ? `, ${transition}` : ''}`,
      height: 76,
      width: 356,
    };
  }

  return newStyle;
};

export const getIsDraggingStyle = isDragging => {
  return isDragging
    ? css`
        align-items: center;
        box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 4px 0 rgba(0, 0, 0, 0.15);
        background-color: ${styles.colors.GRAY_LIGHT};
        height: 76px;
        margin-left: 61px;
        padding-left: 30px;
        width: 376px;
      `
    : '';
};

export const ProductList = styled.div``;

export const Content = styled.div`
  margin-top: 0;
  ${container()};
`;

export const SearchMessageResult = styled.div`
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_4,
    styles.fontWeights.NORMAL
  )};

  > span {
    font-weight: ${styles.fontWeights.SEMIBOLD};
  }
`;

export const ContentLoader = styled.div`
  ${mixins.flexPosition({ justify: 'center' })}
`;

export const ProductsGeneralActionsContainer = styled.div`
  width: 100%;
  background-color: ${styles.colors.GRAY_LIGHT};
  z-index: ${ZINDEX.TOP};
  ${({ numberOfSelected }) =>
    numberOfSelected
      ? css`
          height: 76px;
          visibility: visible;
        `
      : css`
          height: 0px;
          visibility: hidden;
          overflow: hidden;
        `};
  transition: background-color 500ms ease, height 500ms ease;
`;

export const ToggleContainer = styled.div`
  ${mixins.flexPosition({ justify: 'flex-end' })}
  align-self: flex-end;
`;

export const RowDetailsContainer = styled.div`
  ${({ isFiltering }) =>
    css`
      ${mixins.flexPosition({
        align: 'center',
        justify: isFiltering ? 'space-between' : 'flex-end',
      })}
      margin: ${isFiltering ? '30px 0 20px' : '20px 0 10px'};
    `}
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/screens/Product/style.js